import { useState, useEffect } from "react"
import { supabase } from "../database/SupabaseConnector"
import "./Onboarding.css"
import { useNavigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"

export const InviteUserPage = () => {
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    supabase.auth.getSession().then((response) => {
      const {
        data: { session },
      } = response

      if (!session) {
        navigate("/login")
      }
    })

    const authChangeEvent = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (!session) {
          navigate("/login")
        }
      }
    )

    return () => authChangeEvent.data.subscription.unsubscribe()
  }, [])

  const handleSendInvite = async () => {
    try {
      setIsLoading(true)
      setError("")
      setSuccess(false)

      const { data: sessionData } = await supabase.auth.getSession()
      if (!sessionData.session) {
        setError("Please log in to send invites")
        return
      }
      // Get customer ID from customer_membership table
      const { data: membershipData, error: membershipError } = await supabase
        .schema('roles_and_permissions')
        .from('customer_membership')
        .select('customer_id')
        .eq('user_id', sessionData.session.user.id)
        .single()

      if (membershipError || !membershipData?.customer_id) {
        setError("No customer team found")
        return
      }

      const customerId = membershipData.customer_id

      // Call the server-side function to handle the invitation
      const { data, error: inviteError } = await supabase.functions.invoke('send-invite', {
        body: {
          email,
          customerId,
          invitedBy: sessionData.session.user.id,
          role: 'member',
          redirectTo: `${window.location.origin}/signup`
        }
      })

      if (inviteError) {
        console.error("Invite error:", inviteError)
        throw inviteError
      }

      if (data?.error) {
        setError(data.error)
        return
      }

      setSuccess(true)
      setEmail("")
    } catch (error: any) {
      console.error("Invite error:", error)
      setError(error.message || "Failed to send invite")
    } finally {
      setIsLoading(false)
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!isLoading && email) {
      handleSendInvite()
    }
  }

  return (
    <div className="signup-page">
      <form onSubmit={handleSubmit} className="onboarding-form">
        <h1 style={{ fontSize: "24px", marginBottom: "10px" }}>Invite Team Member</h1>
        <p style={{ color: "#596c85", marginBottom: "20px" }}>Send an invitation to join your team</p>
        
        <div className="onboarding-label">Email Address</div>
        <input
          type="email"
          className="onboarding-input"
          style={{ width: "100%", boxSizing: "border-box" }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter email address"
          disabled={isLoading}
        />

        {error && <div className="form-validation-error">{error}</div>}
        {success && (
          <div style={{ color: "#3fcf8e", marginBottom: "15px" }}>
            Invitation sent successfully!
          </div>
        )}

        <button
          type="submit"
          disabled={isLoading || !email}
          className={isLoading ? "onboarding-nav-button onboarding-nav-button-disabled" : "onboarding-nav-button"}
          style={{ width: "100%" }}
        >
          {isLoading ? "Sending..." : "Send Invite"}
        </button>
      </form>
    </div>
  )
} 